<template>
  <div class="ccontainer">
    <div class="prejoin-preview-dropdown-container">
      <div
        aria-label="Comprar 1 minuto extra"
        class="css-1hbmoh1-actionButton secondary"
        role="button"
        tabindex="0"
        @click="toggle"
      >
        {{ $t("videocall.button.tokens_history") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    closeHandler() {
      this.showModal = false;
    },
    close() {
      this.showModal = false;
      this.$emit("close");
    },
    show() {
      this.showModal = true;
      this.$emit("show");
    },
    toggle() {
      if (this.showModal) this.close();
      else this.show();
    },
  }
};
</script>

<style scoped lang="scss" >
@import "../jisti.scss";

.css-1hbmoh1-actionButton {
  user-select: none;
}
</style>
